import styled from 'styled-components';

export const StyledErrorMessage = styled.span`
  svg {
    margin-right: ${({ theme }): string => theme.spacing_unit_x1};
  }
  display: flex;
  color: #cc0000;
  align-items: center;
`;
